/* eslint-disable */
// @ts-nocheck
import * as Types from '../../types.generated.js';

export type GetBlogPostBySlugMetaFormatsFragmentFragment = { __typename?: 'Media', formats?: { __typename?: 'Formats', large?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, medium?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, small?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, thumbnail?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null } | null };

export type GetBlogPostBySlugOverwrittenImagesFragmentFragment = { __typename?: 'Media', formats?: { __typename?: 'Formats', overwrittenLarge?: { __typename?: 'MediaFormat', url?: string | null } | null, overwrittenMedium?: { __typename?: 'MediaFormat', url?: string | null } | null, overwrittenSmall?: { __typename?: 'MediaFormat', url?: string | null } | null, overwrittenThumbnail?: { __typename?: 'MediaFormat', url?: string | null } | null } | null };

export type GetBlogPostBySlugMetaSocialFragmentFragment = { __typename?: 'MetaSocial', image?: { __typename?: 'Media', alternativeText?: string | null, height?: number | null, mime?: string | null, url?: string | null, width?: number | null, formats?: { __typename?: 'Formats', large?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, medium?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, small?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, thumbnail?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null } | null } | null };

export type GetBlogPostBySlugSeoFragmentFragment = { __typename?: 'FullPostAttributes', seo?: { __typename?: 'SEO', id?: string | null, keywords?: string | null, metaDescription?: string | null, metaTitle?: string | null, metaSocial?: { __typename?: 'MetaSocial', description?: string | null, id?: string | null, title?: string | null, image?: { __typename?: 'Media', alternativeText?: string | null, height?: number | null, mime?: string | null, url?: string | null, width?: number | null, formats?: { __typename?: 'Formats', large?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, medium?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, small?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null, thumbnail?: { __typename?: 'MediaFormat', height?: number | null, mime?: string | null, url?: string | null, width?: number | null } | null } | null } | null } | null } | null };

export type GetBlogPostBySlugTagsFragmentFragment = { __typename?: 'FullPostAttributes', tags?: Array<{ __typename?: 'Tag', name?: string | null }> | null };

export type GetBlogPostBySlugImageFragmentFragment = { __typename?: 'FullPostAttributes', featuredImage?: { __typename?: 'Image', authorName?: string | null, authorPortfolio?: string | null, siteLink?: string | null, siteOfImage?: string | null, image?: { __typename?: 'Media', url?: string | null, formats?: { __typename?: 'Formats', overwrittenLarge?: { __typename?: 'MediaFormat', url?: string | null } | null, overwrittenMedium?: { __typename?: 'MediaFormat', url?: string | null } | null, overwrittenSmall?: { __typename?: 'MediaFormat', url?: string | null } | null, overwrittenThumbnail?: { __typename?: 'MediaFormat', url?: string | null } | null } | null } | null } | null };

export type GetBlogPostBySlugCategoryFragmentFragment = { __typename?: 'FullPostAttributes', category?: { __typename?: 'Category', name?: string | null } | null };

export type GetBlogPostBySlugAuthorFragmentFragment = { __typename?: 'FullPostAttributes', authors?: Array<{ __typename?: 'Author', name?: string | null, picture?: { __typename?: 'Media', url?: string | null } | null }> | null };

export type GetBlogCategoriesPaginationFragmentFragment = { __typename?: 'CategoryWithPostsAttributesData', pagination?: { __typename?: 'Pagination', page?: number | null, pageCount?: number | null, pageSize?: number | null, total?: number | null } | null };

export type GetBlogCategoriesPostPaginationFragmentFragment = { __typename?: 'CategoryWithPostsAttributes', postsPagination?: { __typename?: 'Pagination', page?: number | null, pageCount?: number | null, pageSize?: number | null, total?: number | null } | null };

export type GetBlogCategoriesPostFragmentFragment = { __typename?: 'CategoryWithPostsAttributes', posts?: Array<{ __typename?: 'FullPostAttributes', id?: string | null, title?: string | null }> | null, postsPagination?: { __typename?: 'Pagination', page?: number | null, pageCount?: number | null, pageSize?: number | null, total?: number | null } | null };

export type GetBlogCategoriesDataFragmentFragment = { __typename?: 'CategoryWithPostsAttributesData', data?: Array<{ __typename?: 'CategoryWithPostsAttributes', name?: string | null, id?: string | null, posts?: Array<{ __typename?: 'FullPostAttributes', id?: string | null, title?: string | null }> | null, postsPagination?: { __typename?: 'Pagination', page?: number | null, pageCount?: number | null, pageSize?: number | null, total?: number | null } | null }> | null };

export const GetBlogPostBySlugMetaFormatsFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogPostBySlugMetaFormatsFragment on Media {
  formats {
    large {
      height
      mime
      url
      width
    }
    medium {
      height
      mime
      url
      width
    }
    small {
      height
      mime
      url
      width
    }
    thumbnail {
      height
      mime
      url
      width
    }
  }
}
    `;
export const GetBlogPostBySlugMetaSocialFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogPostBySlugMetaSocialFragment on MetaSocial {
  image {
    alternativeText
    ...GetBlogPostBySlugMetaFormatsFragment
    height
    mime
    url
    width
  }
}
    ${GetBlogPostBySlugMetaFormatsFragmentFragmentDoc}`;
export const GetBlogPostBySlugSeoFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogPostBySlugSeoFragment on FullPostAttributes {
  seo {
    id
    keywords
    metaDescription
    metaSocial {
      description
      id
      ...GetBlogPostBySlugMetaSocialFragment
      title
    }
    metaTitle
  }
}
    ${GetBlogPostBySlugMetaSocialFragmentFragmentDoc}`;
export const GetBlogPostBySlugTagsFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogPostBySlugTagsFragment on FullPostAttributes {
  tags {
    name
  }
}
    `;
export const GetBlogPostBySlugOverwrittenImagesFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogPostBySlugOverwrittenImagesFragment on Media {
  formats {
    overwrittenLarge {
      url
    }
    overwrittenMedium {
      url
    }
    overwrittenSmall {
      url
    }
    overwrittenThumbnail {
      url
    }
  }
}
    `;
export const GetBlogPostBySlugImageFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogPostBySlugImageFragment on FullPostAttributes {
  featuredImage {
    authorName
    authorPortfolio
    image {
      url
      ...GetBlogPostBySlugOverwrittenImagesFragment
    }
    siteLink
    siteOfImage
  }
}
    ${GetBlogPostBySlugOverwrittenImagesFragmentFragmentDoc}`;
export const GetBlogPostBySlugCategoryFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogPostBySlugCategoryFragment on FullPostAttributes {
  category {
    name
  }
}
    `;
export const GetBlogPostBySlugAuthorFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogPostBySlugAuthorFragment on FullPostAttributes {
  authors {
    name
    picture {
      url
    }
  }
}
    `;
export const GetBlogCategoriesPaginationFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogCategoriesPaginationFragment on CategoryWithPostsAttributesData {
  pagination {
    page
    pageCount
    pageSize
    total
  }
}
    `;
export const GetBlogCategoriesPostPaginationFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogCategoriesPostPaginationFragment on CategoryWithPostsAttributes {
  postsPagination {
    page
    pageCount
    pageSize
    total
  }
}
    `;
export const GetBlogCategoriesPostFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogCategoriesPostFragment on CategoryWithPostsAttributes {
  posts {
    id
    title
  }
  ...GetBlogCategoriesPostPaginationFragment
}
    ${GetBlogCategoriesPostPaginationFragmentFragmentDoc}`;
export const GetBlogCategoriesDataFragmentFragmentDoc = /*#__PURE__*/ `
    fragment GetBlogCategoriesDataFragment on CategoryWithPostsAttributesData {
  data {
    name
    id
    ...GetBlogCategoriesPostFragment
  }
}
    ${GetBlogCategoriesPostFragmentFragmentDoc}`;